const jobs = {
  forms: {
    information: {
      reservationDetails: {
        fields: {
          from: 'Ubicación de Retirada',
          to: 'Ubicación del viaje',
          seat: 'Paquetes',
        },
      },
    },
  },

  table: {
    headers: {
      seats: 'Cantidad de artículos',
      from: 'Ubicación de Retirada',
      to: 'Ubicación del viaje',
      passenger: 'Nombre del destinatario',
    },
    statuses: {
      picked: 'Salido para la entrega',
      dropped: 'Entregado',
      noshow: 'Entrega fallida',
    },
  },
};

export default jobs;
